export class EstImageSendQuoteModel {
  constructor() {
    this.quoteId = ''
    this.invoiceId = ''
    this.imageIds = []
    this.documentIds = []
    this.assessment = null
  }
}